import { Sort } from '../../../insight/experimental.grid';

import { ColumnType, TemplateID } from './team-grid.model';

export interface CellContext {
    templateId: TemplateID;
    data: any[];
}

export enum OptionalColumnType {
    ACTUAL,
    TARGET,
    PERCENT_TO_TARGET,
    WEIGHT,
    ACTUAL_TYPE,
    TARGET_TYPE,
    PERCENT_TYPE,
    SCORING_TYPE,
    USER_NAME,
    SUPERGROUP_NAME,
    ACTUAL_TREND,
    PERCENT_TO_TARGET_TREND,
    COACHING_PLAN_ACTIVE,
    METRIC_LABEL,
}
export interface OptionalColumn {
    columnType: OptionalColumnType;
    displayOrder: number;
}

export interface DRScorecardMetric {
    metricId: number;
    metricName: string;
    actual: number;
    target: number;
    percentToTarget: number;
    weight: number;
    pointBand: string;
    adjustedPoints: number;
    isInEffect: boolean;
    rank: string;
    pillarId?: number;
    identifier?: string;
}

export interface DirectReportScorecardResult {
    scorecardId?: number;
    subScorecardId?: number;
    subUserId?: number;
    subUserName?: string;
    subSuperGroupId?: number;
    subSuperGroupName?: string;
    subStartDate?: string;
    subEndDate?: string;
    subAdjustedPoints?: number;
    metricId?: number;
    metricName?: string;
    actual?: number;
    target?: number;
    targetPercent?: number;
    pointsBand?: string;
    weight?: number;
    adjustedPoints?: number;
    rank?: number;
    maxRank?: number;
    isInEffect?: boolean;
    sortDefs: Sort[];
    pillarId?: number;
    pillarOrder?: number;
}

export interface DirectReportScorecardDisplay {
    directReport: string;
    userId: number;
    scorecardId: number;
    superGroupId: number;
    superGroup: string;
    period: string;
    overallScore: number;
    weightedMetrics: DRScorecardMetric[];
    fyiMetrics: DRScorecardMetric[];
    modifierMetrics: DRScorecardMetric[];
    qualifierMetrics: DRScorecardMetric[];
    conditionMetrics: DRScorecardMetric[];
}

export interface ScorecardColumnContext {
    templateId: TemplateID;
    type: ColumnType;
    metricId?: string;
    pillarId?: string;
    metricName?: string;
    isColumnExpanded?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RowContext {}

function pluckMetric(
    metricType: number,
    data: DirectReportScorecardDisplay,
    metricId: number,
): DRScorecardMetric {
    switch (metricType) {
        case ColumnType.WEIGHTED:
            return data.weightedMetrics?.find((w) => w.metricId === metricId);
        case ColumnType.FYI:
            return data.fyiMetrics?.find((w) => w.metricId === metricId);
        case ColumnType.MODIFIER:
            return data.modifierMetrics?.find((w) => w.metricId === metricId);
        case ColumnType.QUALIFIER:
            return data.qualifierMetrics?.find((w) => w.metricId === metricId);
        case ColumnType.CONDITION:
            return data.conditionMetrics?.find((w) => w.metricId === metricId);
        default:
            break;
    }
}

// TODO refactor
export function retrieveCellData(
    data: DirectReportScorecardDisplay[],
    metricType: string,
    metricId: string,
    item: string,
): string {
    let ans = '-';
    const metricTypeNum = Number(metricType) as ColumnType;
    let metricIdNum: number;
    if (metricId.split('-').length >= 2) {
        metricIdNum = Number(metricId.split('-')[1]);
    } else {
        metricIdNum = Number(metricId);
    }

    const metric = pluckMetric(metricTypeNum, data[0], metricIdNum);

    if (metric) {
        ans = metric[item];
    }

    if (metric) {
        switch (item) {
            case 'actual':
                return metric?.actual ? metric?.actual.toFixed(2) : '-';
            case 'target':
                return metric?.target != null ? metric?.target.toFixed(2) : '-';
            case 'percentToTarget':
                return metric?.percentToTarget != null
                    ? (metric?.percentToTarget * 100).toFixed(2)
                    : '-';
            case 'pointBand':
                return metric?.pointBand != null ? metric?.pointBand : '-';
            case 'weight':
                return metric?.weight != null
                    ? (metric?.weight * 100).toFixed(2)
                    : '-';
            case 'adjustedPoints':
                return metric?.adjustedPoints != null
                    ? metric?.adjustedPoints.toFixed(2)
                    : '-';
            case 'rank':
                return metric?.rank != null ? metric?.rank : '-';
            case 'isInEffect':
                return metric?.isInEffect != null
                    ? metric?.isInEffect
                        ? 'Yes'
                        : 'No'
                    : '-';
            default:
                return '-';
        }
    }
    return ans;
}

export function retrieveExpandedCellData(
    data: DirectReportScorecardDisplay[],
    metricType: string,
    metricId: string,
    item: string,
): string {
    let ans = '-';
    const mType = parseInt(metricType.split('-')[0]);
    const mId = parseInt(metricType.split('-')[1]);

    const metric = pluckMetric(mType, data[0], mId);

    if (item === 'percentToTarget') {
        return metric?.percentToTarget != null
            ? `${(metric.percentToTarget * 100).toFixed(2)}%`
            : ans;
    }

    if (item === 'weight') {
        return metric?.weight != null
            ? `${(metric.weight * 100).toFixed(2)}%`
            : ans;
    }

    if (metric) {
        ans = metric[item];
    }

    if (item === 'isInEffect' && ans != null && ans !== '-') {
        // TODO translate. tl
        return ans ? 'Yes' : 'No';
    }

    if (ans === '' || ans == null) {
        return '-';
    }

    // TODO is this needed?
    if ((item && item === 'pointBand') || item === 'rank') {
        return ans;
    }

    if (typeof ans === 'number') {
        // TODO use number transformer
        return (ans as number).toFixed(2);
    }

    return ans;
}
